import {AxiosInstance} from "axios";
import {ExamType} from "../../models/exam";
import {responseHandler} from "./response";

export const registerMessagingToken = async (client: AxiosInstance, token: string) =>
    responseHandler<string>(client.post(`/notifications/registerCloudMessagingToken`, {
        messagingToken: token
    }))